import { useEffect, useState } from "react";
import { api, type AuditEntry, type RenderEntry } from "@/lib/api";

export function Audit() {
  const [tab, setTab] = useState<"log" | "renders">("log");
  const [log, setLog] = useState<AuditEntry[]>([]);
  const [renders, setRenders] = useState<RenderEntry[]>([]);

  useEffect(() => {
    void api.get<{ data: AuditEntry[] }>("/api/audit?limit=200").then((r) => setLog(r.data));
    void api.get<{ data: RenderEntry[] }>("/api/audit/renders?limit=100").then((r) => setRenders(r.data));
  }, []);

  return (
    <div className="rounded-xl border border-border bg-card p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-semibold">Audit-Log</h2>
        <div className="flex gap-1 text-sm">
          <button
            type="button"
            onClick={() => setTab("log")}
            className={`px-3 py-1.5 rounded-md ${tab === "log" ? "bg-secondary" : "text-muted-foreground"}`}
          >
            Aktionen
          </button>
          <button
            type="button"
            onClick={() => setTab("renders")}
            className={`px-3 py-1.5 rounded-md ${tab === "renders" ? "bg-secondary" : "text-muted-foreground"}`}
          >
            PDF-Renders
          </button>
        </div>
      </div>
      {tab === "log" ? (
        <table className="w-full text-xs">
          <thead>
            <tr className="border-b border-border text-left text-muted-foreground">
              <th className="py-2 pr-3 font-medium">Zeit</th>
              <th className="py-2 pr-3 font-medium">User</th>
              <th className="py-2 pr-3 font-medium">Rolle</th>
              <th className="py-2 pr-3 font-medium">Aktion</th>
              <th className="py-2 pr-3 font-medium">Ziel</th>
              <th className="py-2 pr-3 font-medium">Payload</th>
            </tr>
          </thead>
          <tbody>
            {log.map((e) => (
              <tr key={e.id} className="border-b border-border/40 hover:bg-secondary/30">
                <td className="py-1.5 pr-3 font-mono">{String(e.ts).replace("T", " ").slice(0, 19)}</td>
                <td className="py-1.5 pr-3">{e.user_email}</td>
                <td className="py-1.5 pr-3 uppercase tracking-wider">{e.user_role}</td>
                <td className="py-1.5 pr-3 font-mono">{e.action}</td>
                <td className="py-1.5 pr-3">{e.target_type ? `${e.target_type}:${e.target_id}` : "—"}</td>
                <td className="py-1.5 pr-3 font-mono text-[10px] text-muted-foreground max-w-md truncate">
                  {e.payload ? JSON.stringify(e.payload) : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <table className="w-full text-xs">
          <thead>
            <tr className="border-b border-border text-left text-muted-foreground">
              <th className="py-2 pr-3 font-medium">Zeit</th>
              <th className="py-2 pr-3 font-medium">SKU</th>
              <th className="py-2 pr-3 font-medium">Sprache</th>
              <th className="py-2 pr-3 font-medium">Attempts</th>
              <th className="py-2 pr-3 font-medium">Scale</th>
              <th className="py-2 pr-3 font-medium">Overflow</th>
              <th className="py-2 pr-3 font-medium">Dauer</th>
              <th className="py-2 pr-3 font-medium">User</th>
            </tr>
          </thead>
          <tbody>
            {renders.map((r) => (
              <tr key={r.id} className="border-b border-border/40 hover:bg-secondary/30">
                <td className="py-1.5 pr-3 font-mono">{String(r.ts).replace("T", " ").slice(0, 19)}</td>
                <td className="py-1.5 pr-3 font-medium">{r.sku}</td>
                <td className="py-1.5 pr-3 font-mono">{r.lang}</td>
                <td className="py-1.5 pr-3">{r.attempts}</td>
                <td className="py-1.5 pr-3 font-mono">{Number(r.final_font_scale).toFixed(2)}</td>
                <td className="py-1.5 pr-3">{r.overflowed ? "⚠️" : "✓"}</td>
                <td className="py-1.5 pr-3 font-mono">{r.duration_ms} ms</td>
                <td className="py-1.5 pr-3 text-muted-foreground">{r.requested_by ?? "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
